import axios from 'axios';
import AudioCubeApiCallerInstance from '../utils/AudioCubeApiCallerInstance';
import { SOUNDBOX_API_ENDPOINTS } from '../URLConstants';

export const getPinCodeDetails = async (pincode) => {
  const response = await axios.get(`https://api.postalpincode.in/pincode/${pincode}`);
  return response;
};

export const GetAllBranchAndregion = async (type) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS.GET_ALL_BRANCH_AND_REGION}${type}`
  );
  return response;
};

export const GetAllZoneHeadOffices = async (where) => {
  const response = await AudioCubeApiCallerInstance.get(
    SOUNDBOX_API_ENDPOINTS?.GET_ZONE_HEAD_OFFICES,
    {
      params: {
        where: JSON.stringify(where)
      }
    }
  );
  return response;
};

export const GetZones = async (page, limit) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS?.GET_ZONES}?page=${page}&limit=${limit}`
  );
  return response;
};

export const GetRegions = async (page, limit) => {
  const response = await AudioCubeApiCallerInstance.get(
    `${SOUNDBOX_API_ENDPOINTS?.GET_REGIONS}?page=${page}&limit=${limit}`
  );
  return response;
};

export const GetSearchZones = async (headOfficeId) => {
  let url = `${SOUNDBOX_API_ENDPOINTS?.GET_ZONES_SEARCH}`;

  if (headOfficeId) {
    url += `?headOfficeId=${headOfficeId}`;
  }

  const response = await AudioCubeApiCallerInstance.get(url);
  return response;
};

export const GetSearchHeadOffices = async () => {
  const response = await AudioCubeApiCallerInstance.get(
    SOUNDBOX_API_ENDPOINTS?.GET_ZONE_HEAD_OFFICES_SEARCH
  );
  return response;
};

export const GetSearchBranches = async (regionalOfficeId) => {
  const response = await AudioCubeApiCallerInstance.get(SOUNDBOX_API_ENDPOINTS?.GET_BRANCHES_SEARCH, {
    params: {
      where: JSON.stringify({
        // ...(headOfficeName ? { headOfficeName } : {}),
        // ...(zonalOfficeName ? { zonalOfficeName } : {}),
        ...(regionalOfficeId ? { regionalOfficeId } : {})
      })
    }
  })
  return response;
};

export const GetSearchRegions = async (headOfficeId, zoneOfficeId) => {
  const response = await AudioCubeApiCallerInstance.get(SOUNDBOX_API_ENDPOINTS?.GET_REGIONS_SEARCH, {
    params: {
      where: JSON.stringify({
        ...(headOfficeId ? { headOfficeId } : {}),
        ...(zoneOfficeId ? { zoneOfficeId } : {}),
      })
    }
  })
  return response;
};

